

if($(window).width() < 991){
  setTimeout(
    function(){
      $('#AddToCartForm_id .cart-btn').clone().addClass('fix-cart-btn').appendTo("body");
    }, 1000);

  $(document).on('click', '.fix-cart-btn', function(){   
    $('#AddToCartForm_id .cart-btn').trigger('click');
  });

  $(document).ready( function() {
    var Wwidth = $(window).width();
    $.fn.is_on_screen = function(){
      var win = $(window);
      var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();

      var bounds = this.offset();
      bounds.right = bounds.left + this.outerWidth();
      bounds.bottom = bounds.top + this.outerHeight();

      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };

    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 1100) {
        $('.fix-cart-btn').show();

        if( $('footer').length > 0 ) {              
          if( $('footer').is_on_screen() ) {            
            $('.fix-cart-btn').hide();
          } else {
            $('.fix-cart-btn').show();
          }
        }     
      } else {
        $('.fix-cart-btn').hide();
      }   
    });
  });
}